import type { CompanySummary, ProductOffer, TeamMember } from '../../types';

/**
 * Catalogo FICTICIO compartilhado pela previa do painel (RNF19).
 *
 * Toda tela simulada le empresas, ofertas e equipe DAQUI, e nao de listas
 * proprias: e o que faz o nome da empresa no cabecalho, o produto na tabela de
 * leads e a oferta no funil serem o mesmo, em qualquer pagina.
 *
 * Regras que mantem o catalogo inconfundivel com producao:
 *  - todo id comeca com "SIMULADO-";
 *  - empresas, produtos, nomes e e-mails sao inventados. NAO reproduzir
 *    produtos de clientes reais nem de outras plataformas;
 *  - nenhum Math.random: a mesma tela mostra sempre o mesmo conjunto.
 */

export const EMPRESA_DEMO_ID = 'SIMULADO-empresa-demo';

export const EMPRESAS: readonly CompanySummary[] = [
  {
    id: EMPRESA_DEMO_ID,
    name: 'Escola Fluente',
    slug: 'escola-fluente',
    segment: 'Cursos de idiomas online',
    logoInitials: 'EF',
    logoTone: 1,
    logoUrl: null,
    feeBps: 1_500,
    billingModel: 'contrato',
    status: 'ativa',
    providers: ['kiwify', 'hotmart'],
    funnels: ['carrinho_abandonado', 'expirados'],
    contactName: 'Camila Rocha',
    contactEmail: 'camila@escolafluente.exemplo',
    createdAt: '2026-06-02T13:00:00.000Z',
  },
  {
    id: 'SIMULADO-empresa-fit',
    name: 'FitPro Treinos',
    slug: 'fitpro-treinos',
    segment: 'Assinatura de treinos e nutricao',
    logoInitials: 'FP',
    logoTone: 3,
    logoUrl: null,
    feeBps: 2_000,
    billingModel: 'automatico',
    status: 'ativa',
    providers: ['shopify', 'kiwify'],
    funnels: ['carrinho_abandonado', 'expirados'],
    contactName: 'Diego Martins',
    contactEmail: 'diego@fitpro.exemplo',
    createdAt: '2026-07-15T12:00:00.000Z',
  },
  {
    id: 'SIMULADO-empresa-dev',
    name: 'CodeLab Cursos',
    slug: 'codelab-cursos',
    segment: 'Formacao em programacao',
    logoInitials: 'CL',
    logoTone: 7,
    logoUrl: null,
    feeBps: 1_500,
    billingModel: 'contrato',
    status: 'ativa',
    providers: ['hotmart'],
    funnels: ['carrinho_abandonado'],
    contactName: 'Renata Alves',
    contactEmail: 'renata@codelab.exemplo',
    createdAt: '2026-08-20T15:30:00.000Z',
  },
  {
    id: 'SIMULADO-empresa-bem',
    name: 'Bem Viver Terapias',
    slug: 'bem-viver',
    segment: 'Programas de bem-estar',
    logoInitials: 'BV',
    logoTone: 5,
    logoUrl: null,
    feeBps: 1_800,
    billingModel: 'a_definir',
    status: 'onboarding',
    providers: ['kiwify'],
    funnels: ['carrinho_abandonado'],
    contactName: 'Paulo Henrique',
    contactEmail: 'paulo@bemviver.exemplo',
    createdAt: '2026-09-18T18:00:00.000Z',
  },
];

export const OFERTAS: readonly ProductOffer[] = [
  { id: 'SIMULADO-oferta-001', companyId: EMPRESA_DEMO_ID, name: 'Inglês Intensivo 12 meses', priceCents: 49_700, recurring: false, provider: 'kiwify', active: true },
  { id: 'SIMULADO-oferta-002', companyId: EMPRESA_DEMO_ID, name: 'Mentoria de Conversação Pro', priceCents: 129_900, recurring: false, provider: 'hotmart', active: true },
  { id: 'SIMULADO-oferta-003', companyId: EMPRESA_DEMO_ID, name: 'Clube de Prática (mensal)', priceCents: 9_700, recurring: true, provider: 'kiwify', active: true },
  { id: 'SIMULADO-oferta-004', companyId: EMPRESA_DEMO_ID, name: 'Espanhol do Zero', priceCents: 39_700, recurring: false, provider: 'kiwify', active: true },
  { id: 'SIMULADO-oferta-005', companyId: EMPRESA_DEMO_ID, name: 'Planner de Estudos', priceCents: 4_700, recurring: false, provider: 'hotmart', active: false },
  { id: 'SIMULADO-oferta-006', companyId: EMPRESA_DEMO_ID, name: 'Imersão de Fluência (anual)', priceCents: 89_700, recurring: true, provider: 'hotmart', active: true },

  { id: 'SIMULADO-oferta-101', companyId: 'SIMULADO-empresa-fit', name: 'Plano Trimestral', priceCents: 29_700, recurring: true, provider: 'shopify', active: true },
  { id: 'SIMULADO-oferta-102', companyId: 'SIMULADO-empresa-fit', name: 'Plano Anual', priceCents: 89_700, recurring: true, provider: 'shopify', active: true },
  { id: 'SIMULADO-oferta-103', companyId: 'SIMULADO-empresa-fit', name: 'Consultoria Nutricional', priceCents: 49_900, recurring: false, provider: 'kiwify', active: true },
  { id: 'SIMULADO-oferta-104', companyId: 'SIMULADO-empresa-fit', name: 'Kit de Elásticos', priceCents: 12_900, recurring: false, provider: 'shopify', active: true },

  { id: 'SIMULADO-oferta-201', companyId: 'SIMULADO-empresa-dev', name: 'Bootcamp Full Stack', priceCents: 199_700, recurring: false, provider: 'hotmart', active: true },
  { id: 'SIMULADO-oferta-202', companyId: 'SIMULADO-empresa-dev', name: 'JavaScript Essencial', priceCents: 29_700, recurring: false, provider: 'hotmart', active: true },
  { id: 'SIMULADO-oferta-203', companyId: 'SIMULADO-empresa-dev', name: 'Assinatura Trilhas', priceCents: 5_900, recurring: true, provider: 'hotmart', active: true },

  { id: 'SIMULADO-oferta-301', companyId: 'SIMULADO-empresa-bem', name: 'Programa 21 Dias', priceCents: 19_700, recurring: false, provider: 'kiwify', active: true },
  { id: 'SIMULADO-oferta-302', companyId: 'SIMULADO-empresa-bem', name: 'Mentoria Individual', priceCents: 89_000, recurring: false, provider: 'kiwify', active: true },
];

export const EQUIPE: readonly TeamMember[] = [
  { id: 'SIMULADO-usuario-001', companyId: EMPRESA_DEMO_ID, name: 'Camila Rocha', email: 'camila@escolafluente.exemplo', role: 'owner', lastAccessAt: '2026-09-24T11:40:00.000Z' },
  { id: 'SIMULADO-usuario-002', companyId: EMPRESA_DEMO_ID, name: 'Thiago Lima', email: 'thiago@escolafluente.exemplo', role: 'member', lastAccessAt: '2026-09-23T20:05:00.000Z' },
  { id: 'SIMULADO-usuario-003', companyId: EMPRESA_DEMO_ID, name: 'Juliana Costa', email: 'juliana.comercial@escolafluente.exemplo', role: 'comercial', lastAccessAt: '2026-09-24T10:15:00.000Z' },
  { id: 'SIMULADO-usuario-004', companyId: EMPRESA_DEMO_ID, name: 'Bruna Alves', email: 'bruna.comercial@escolafluente.exemplo', role: 'comercial', lastAccessAt: '2026-09-24T09:02:00.000Z' },
  { id: 'SIMULADO-usuario-102', companyId: 'SIMULADO-empresa-fit', name: 'Patrícia Nogueira', email: 'patricia.comercial@fitpro.exemplo', role: 'comercial', lastAccessAt: '2026-09-23T18:40:00.000Z' },
  { id: 'SIMULADO-usuario-101', companyId: 'SIMULADO-empresa-fit', name: 'Diego Martins', email: 'diego@fitpro.exemplo', role: 'owner', lastAccessAt: '2026-09-24T09:10:00.000Z' },
  { id: 'SIMULADO-usuario-201', companyId: 'SIMULADO-empresa-dev', name: 'Renata Alves', email: 'renata@codelab.exemplo', role: 'owner', lastAccessAt: '2026-09-22T16:00:00.000Z' },
  { id: 'SIMULADO-usuario-301', companyId: 'SIMULADO-empresa-bem', name: 'Paulo Henrique', email: 'paulo@bemviver.exemplo', role: 'owner', lastAccessAt: null },
];

export function empresaPorId(id: string): CompanySummary | null {
  return EMPRESAS.find((e) => e.id === id) ?? null;
}

export function ofertasDaEmpresa(companyId: string): readonly ProductOffer[] {
  return OFERTAS.filter((o) => o.companyId === companyId);
}

export function equipeDaEmpresa(companyId: string): readonly TeamMember[] {
  return EQUIPE.filter((m) => m.companyId === companyId);
}

/** Nome de oferta por posicao, para gerar listas simuladas sem repetir texto. */
export function ofertaCiclica(companyId: string, index: number): ProductOffer {
  const lista = ofertasDaEmpresa(companyId);
  const fallback: ProductOffer = {
    id: 'SIMULADO-oferta-000',
    companyId,
    name: 'Produto de exemplo',
    priceCents: 9_900,
    recurring: false,
    provider: 'kiwify',
    active: true,
  };
  if (lista.length === 0) {
    return fallback;
  }
  return lista[index % lista.length] ?? fallback;
}
